import { useEffect } from "react";
import MultiplexAd from "./AdUnits/MultiplexAd";
import {
  ADSENSE_MULTIPLEX_VERTICAL_SLOT,
  isAdSenseHostAllowed,
} from "../config/adsense.js";

const VerticalAd = ({ onSlotStateChange }) => {
  useEffect(() => {
    if (!isAdSenseHostAllowed() || !ADSENSE_MULTIPLEX_VERTICAL_SLOT) {
      onSlotStateChange?.("unfilled");
    }
  }, [onSlotStateChange]);

  return (
    <div style={{ textAlign: "center", margin: "8px 0" }}>
      <div className="ad-slot--vertical">
        <MultiplexAd orientation="vertical" onSlotStateChange={onSlotStateChange} />
      </div>
    </div>
  );
};

export default VerticalAd;
